// extracted by mini-css-extract-plugin
export default {"lds_dual_ring":"Loading_lds_dual_ring__W4SE6"};